import Grid from "elements/Grid";
import Button from "elements/Button";
import ContactHeroIcon from "public/contact/contact-hero.svg";
import HelpCenterGraphicSVG from "public/help-center-graphic.svg";
import Link from "next/link";
import { sendWebhookToHelpCenter } from "utils/sendWebhook";
import Script from "next/script";
import { useAppContext } from "context/AppContext";
import { useEventTracker_DEPRECATED } from "utils/useEventTracker";
import constants from "utils/constants";
import { useAuthContext } from "context/AuthContext";
import { useEffect, useState } from "react";
import { getAllDifferentNeedsAttentionReasons } from "utils/getDistinctNeedsAttentionReasons";
import ButtonV2 from "elements/ButtonV2";

const WEBHOOK_CONTACT_CTA = "Clicked Contact button";

type MixpanelLocations = "home" | "category" | "section" | "article";

const ContactUsSection = ({
	mixpanelLocation,
}: {
	mixpanelLocation: MixpanelLocations;
}) => {
	const [distinctNeedsAttentionReasons, setDistinctNeedsAttentionReasons] =
		useState<string[]>([]);
	const { mixpanelInitialized } = useAppContext();
	const { isAuthenticated, properties } = useAuthContext();

	useEffect(() => {
		setDistinctNeedsAttentionReasons(
			getAllDifferentNeedsAttentionReasons({ properties })
		);
	}, [properties]);

	const trackContactUsClickFromHelpCenter = useEventTracker_DEPRECATED(
		constants.EVENTS.HELP_CENTER_SUBMIT_REQUEST_BUTTON,
		{
			"User Type": isAuthenticated ? "Existing" : "New",
		}
	);
	const trackContactUsClickFromCategory = useEventTracker_DEPRECATED(
		constants.EVENTS.HELP_CENTER_SUBMIT_REQUEST_FROM_CATEGORY,
		{
			"User Type": isAuthenticated ? "Existing" : "New",
		}
	);
	const trackContactUsClickFromSection = useEventTracker_DEPRECATED(
		constants.EVENTS.HELP_CENTER_SUBMIT_REQUEST_FROM_SECTION,
		{
			"User Type": isAuthenticated ? "Existing" : "New",
		}
	);
	const trackContactUsClickFromArticle = useEventTracker_DEPRECATED(
		constants.EVENTS.HELP_CENTER_SUBMIT_REQUEST_FROM_ARTICLE,
		{
			"User Type": isAuthenticated ? "Existing" : "New",
		}
	);

	const trackCallUsClickFromHelpCenter = useEventTracker_DEPRECATED(
		constants.EVENTS.HELP_CENTER_CALL_US_FROM_HELP_CENTER,
		{
			"User Type": isAuthenticated ? "Existing" : "New",
			Status: distinctNeedsAttentionReasons.length
				? distinctNeedsAttentionReasons
				: "None",
		}
	);
	const trackCallUsClickFromCategory = useEventTracker_DEPRECATED(
		constants.EVENTS.HELP_CENTER_CALL_US_FROM_CATEGORY,
		{
			"User Type": isAuthenticated ? "Existing" : "New",
			Status: distinctNeedsAttentionReasons.length
				? distinctNeedsAttentionReasons
				: "None",
		}
	);
	const trackCallUsClickFromSection = useEventTracker_DEPRECATED(
		constants.EVENTS.HELP_CENTER_CALL_US_FROM_SECTION,
		{
			"User Type": isAuthenticated ? "Existing" : "New",
			Status: distinctNeedsAttentionReasons.length
				? distinctNeedsAttentionReasons
				: "None",
		}
	);
	const trackCallUsClickFromArticle = useEventTracker_DEPRECATED(
		constants.EVENTS.HELP_CENTER_CALL_US_FROM_ARTICLE,
		{
			"User Type": isAuthenticated ? "Existing" : "New",
			Status: distinctNeedsAttentionReasons.length
				? distinctNeedsAttentionReasons
				: "None",
		}
	);

	const handleContactUsClick = () => {
		sendWebhookToHelpCenter(WEBHOOK_CONTACT_CTA);
		if (mixpanelInitialized) {
			if (mixpanelLocation === "home") {
				trackContactUsClickFromHelpCenter();
			} else if (mixpanelLocation === "category") {
				trackContactUsClickFromCategory();
			} else if (mixpanelLocation === "section") {
				trackContactUsClickFromSection();
			} else if (mixpanelLocation === "article") {
				trackContactUsClickFromArticle();
			}
		}
	};

	const handleCallUsClick = () => {
		if (mixpanelInitialized) {
			if (mixpanelLocation === "home") {
				trackCallUsClickFromHelpCenter();
			} else if (mixpanelLocation === "category") {
				trackCallUsClickFromCategory();
			} else if (mixpanelLocation === "section") {
				trackCallUsClickFromSection();
			} else if (mixpanelLocation === "article") {
				trackCallUsClickFromArticle();
			}
		}
	};
	return (
		<Grid id="contactus-title-section" className="help-center-new-request">
			<HelpCenterGraphicSVG id="help-center-graphic" />
			<div id="contactus-title-container">
				<h4>Can’t find what you’re looking for?</h4>
				<p id="contactus-subtitle">The Ownwell team is here to help.</p>
				<div id="contactus-view-cta-container">
					<div id="contactus-view-cta-container-inner">
						<p id="contactus-email">
							Send us an email&nbsp;at{" "}
							<a href="mailto:support@ownwell.com">support@ownwell.com</a>
						</p>
						<p>or</p>
						<div id="contactus-view-phone-container">
							<Link
								passHref
								href="/help/call"
								onClick={() => handleCallUsClick()}>
								<ButtonV2
									size="small"
									variant="primary-outline"
									id="contactus-view-phone-btn">
									Call Us
								</ButtonV2>
							</Link>
						</div>
					</div>
				</div>
			</div>
		</Grid>
	);
};

export default ContactUsSection;
